import axios from 'axios';

import request from '@/api/axiosFun'

export  const addOrder=(data)=>{
    return request({
            url:"order/addorder",
            method:"post",
            data
        })
    }
//更新订单


export  const editOrder=(data)=>{
    return request({
            url:"order/editOrder",
            method:"post",
            data
        })
    }

export  const listOrder=(data)=>{
        return request({
                url:"order/list",
                method:"post",
                data
            })
        }

//获取有效的业务员

export  const salesmanList=()=>{
    return request({
            url:"customer/get_customer_valid",
            method:"post",
           // data
        })
    }
//g根据id获取表单数据

export const oderById=(id)=>{
    return request({
        url:"order/oderById",
        method:"post",
        data:{
            id
        }
    })  
}
//搜索
export const search=(where)=>{
    return request({
        url:"order/search",
        method:"post",
        data:where
    })  
}

//导出数据

export const export_data=(where)=>{
    return request({
        url:"DataCenter/export_data",
        method:"post",
        data:where
    })  

}


export const getMealData=(id)=>{  //根据p_id获取宽带套餐
    return request({
        url:"order/getmeal",
        method:"post",
        data:{
            id
        }
    })  

}
//获取供应商
export const getprovide=()=>{
    return request({
        url:"order/getprovide",
        method:"post",
    })  

}

export const getTypeData=()=>{
    return request({
        url:"order/getTypeData",
        method:"post",
        
    })  

}
export const getbelong=()=>{
    return request({
        url:"order/getbelong",
        method:"post",
    })  
}
export const getStatus=()=>{
    return request({
        url:"system/StatusList",
        method:"post",
    })  
}

export const get_role=()=>{
    return request({
        url:"system/get_role",
        method:"post",
    })  
}
export const handlock=(id)=>{
    return request({
        url:"order/handlock",
        method:"post",
        data:{
            id
        }
    })  
}

export const handUnlock=(id)=>{
    return request({
        url:"order/handunlock",
        method:"post",
        data:{
            id
        }
    })  
}

export const OverdueNum=()=>{
    return request({
        url:"order/OverdueNum",
        method:"post",
    })  
}

export const deleteOrder=(id)=>{
    return request({
        url:"order/deleteOrder",
        method:"post",
        data:{
            id
        }
    })  
}


export const editStatus=(data)=>{//代理商修改状态
    return request({
        url:"order/changeStatus",
        method:"post",
        data
    })  
}


export  const getcard_info=(data)=>{ //用户身份信息
    return request({
            url:"order/GetDyOrderUserInfo",
            method:"post",
            data
        })
    }

export const  submitTzOrder=(data)=>{ //提交土洲订单
        return request({
            url:"TuzhouOrder/submitOrder",
            method:"post",
            data
           
        })
    }     
export const  getKdCode=(data)=>{ //获取宽带编码
        return request({
            url:"TuzhouOrder/getKdCode",
            method:"post",
            data
           
        })
    } 
export const  getTzProduct=(data)=>{ //获取土洲产品
        return request({
            url:"TuzhouOrder/getTzProduct",
            method:"post",
            data
           
        })
    }   


export const  getBaiduOrder=()=>{ //获取百度订单
        return request({
            url:"Order/getBaiduOrder",
            method:"post",
         
        })
    }   


    export const  ChangeBaiduOrder=(data)=>{ //修改百度订单状态
        return request({
            url:"Order/ChangeBaiduOrder",
            method:"post",
            data
         
        })
    }   
    
            
        
  


// WEBPACK FOOTER //
// ./src/api/order.js